module.exports = __webpack_public_path__ + "static/media/iconGreen.1e03fa61.svg";